// libs
import React, { memo } from 'react';
import { useResponsiveContext } from 'shared/components/ResponsiveLoader/ResponsiveContext';

// components
import WishlistTitle from 'shared/layouts/Wishlist/Mobile/components/WishlistTitle';
import WishlistTitleDesktop from 'shared/layouts/Wishlist/Desktop/Components/WishlistTitle';
import WishlistTopBanner from 'shared/layouts/Wishlist/Mobile/components/WishlistTopBanner';

// constants
import { BREAKPOINTS } from 'shared/styles/base';

// defs
interface IWishlistHeader {
  totalProductsInWishlist: number;
}
function WishlistHeader({ totalProductsInWishlist }: IWishlistHeader) {
  const { deviceWidth } = useResponsiveContext();
  const isDesktop = deviceWidth >= BREAKPOINTS.DESKTOP;

  if (isDesktop) {
    return <WishlistTitleDesktop totalProductsInWishlist={totalProductsInWishlist} />;
  }
  return (
    <>
      <WishlistTitle totalProductsInWishlist={totalProductsInWishlist} />
      <WishlistTopBanner />
    </>
  );
}

export default memo(WishlistHeader);
